class CoHeaderDesktopNav extends HTMLElement {
     constructor() {
    super();
    }

    connectedCallback() {
    this._header = document.querySelector('header');

    this._bindMenuPositions();
    this._bindScrollResize();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScrollResize);
    window.removeEventListener('resize', this._onScrollResize);
  }

  _updateMenuPosition(menu) {
    if (!this._header) return;

    const scrollbarHeight = this.offsetHeight - this.clientHeight;

    if(scrollbarHeight > 0) {
        menu.style.top = `${this._header.offsetHeight - scrollbarHeight}px`;
    } else {
        menu.style.top = `${this._header.offsetHeight}px`;
    }

  }

  _bindMenuPositions() {
    this.querySelectorAll('.site-nav__details').forEach((details) => {
      const menu = details.querySelector('.site-nav__dropdown');
      if (!menu) return;

      details.addEventListener('mouseenter', () => {
        if (details.open) this._updateMenuPosition(menu);
      });

      details.addEventListener('toggle', () => {
        if (details.open) this._updateMenuPosition(menu);
      });
    });
  }

  _bindScrollResize() {
    this._onScrollResize = () => {
      this.querySelectorAll('details[open] .site-nav__dropdown').forEach((menu) => {
        this._updateMenuPosition(menu);
      });
    };

    window.addEventListener('scroll', this._onScrollResize, { passive: true });
    window.addEventListener('resize', this._onScrollResize, { passive: true });
  }
}

if (!customElements.get("co-header-desktop-nav")) {
	customElements.define("co-header-desktop-nav", CoHeaderDesktopNav);
}